export const getFormatedPatchedArgs = data =>
	Object.keys(data).map(key => ({
		op:    (data[key] === null || data[key].length === 0) ? 'remove' : 'replace',
		path:  `/${key}`,
		value: (data[key] === null || data[key].length === 0 ? null : data[key]),
	}));
